module.exports = __webpack_public_path__ + "static/media/ReCap Pro.47012da1.png";